import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext, useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import { TERMS_TYPE } from 'constants/IncorporationConstants';
import { getHostDomain } from 'utils/common';
import TextFieldHookForm from 'components/Common/InputBox/TextFieldHookForm';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import * as employeeActions from 'redux/ducks/Employee/EmployeeDucks';

export const IdForm = ({ disabled, isAdmin, svcType }) => {
  const dispatch = useDispatch();
  const { isPossible, duplicateId } = useSelector(state => state.employee);
  const { employeeVo } = useSelector(state => state.account);
  const userId = useWatch({ name: 'userId' });

  const ID_LENGTH = svcType?.includes(TERMS_TYPE.PORTAL) ? 20 : 100;
  const {
    getValues,
    formState: { errors },
    setValue,
  } = useFormContext();

  const getRowHeader = () => {
    return (employeeVo.userId && employeeVo.userId.indexOf('@') > -1) || !svcType.includes(TERMS_TYPE.PORTAL)
      ? 'ID'
      : `ID (${userId ? userId.length : 0}/${ID_LENGTH}) `;
  };

  useEffect(() => {
    if (isPossible) {
      dispatch(employeeActions.initDuplicate());
    }
  }, [userId]);

  useEffect(() => {
    if (employeeVo.userId && employeeVo.userId.indexOf('@') > -1) {
      setValue('userId', employeeVo.userId);
    }
  }, [employeeVo]);

  const getEmailDomain = () => {
    let domain = '';
    if (isAdmin) {
      domain = getHostDomain();
    } else {
      domain = employeeVo.emailAddr;
    }
    return domain;
  };

  const getUserIdPlaceHolder = () => {
    return employeeVo.emailAddr ? `abc${getEmailDomain()}` : `abc${getHostDomain()}`;
  };

  return (
    <>
      <TblRow>
        <TblRowHeader rowHeader={getRowHeader()} isRequired />
        {!disabled && employeeVo.userId?.indexOf('@') > -1 ? ( // userId에 @있으면 ID즉시발급 사용자로 판단
          <TblRowTail>{employeeVo.userId}</TblRowTail>
        ) : (
          <TblRowTail
            buttonChildren={
              <>
                <span className="text">{!disabled && getEmailDomain()}</span>
                <Button
                  componentType="solid"
                  className="primary ie-btn"
                  label={i18n.t('MB_T_COMMON_DOUBLECHECK')}
                  disabled={disabled}
                  onClick={() => {
                    if (!errors.userId) {
                      dispatch(
                        employeeActions.duplicateIdCheck({ query: `${getValues('userId')}${getEmailDomain()}` }),
                      );
                    }
                  }}
                />
              </>
            }
          >
            <TextFieldHookForm
              name="userId"
              className=""
              maxLength={ID_LENGTH}
              disabled={disabled}
              placeholderLabel={isAdmin ? i18n.t('MB_T_ID_HOLDER') : getUserIdPlaceHolder()}
              useTooltip
              tooltipTitle={i18n.t('MB_T_ID_CREATION_RULE_TITLE')}
              tooltipLabels={[
                i18n.t('MB_T_ID_CREATION_RULE_LABEL_1'),
                i18n.t('MB_T_ID_CREATION_RULE_LABEL_2'),
                i18n.t('MB_T_ID_CREATION_RULE_LABEL_3'),
                i18n.t('MB_T_ID_CREATION_RULE_LABEL_4'),
              ]}
            />
            {duplicateId && (
              <div className="input-add-exp">
                <span className="text color-warning">{i18n.t(duplicateId.errorCode)}</span>
              </div>
            )}
            {isPossible && (
              <div className="input-add-exp">
                <span className="text color-primary">{i18n.t('MB_M_EMAIL_VALIDATED')}</span>
              </div>
            )}
          </TblRowTail>
        )}
      </TblRow>
    </>
  );
};
IdForm.propTypes = { disabled: PropTypes.bool, isAdmin: PropTypes.bool, svcType: PropTypes.string };
IdForm.defaultProps = { disabled: false, isAdmin: false, svcType: '' };
export default IdForm;
